const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const approveCodes = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: ApproveDeclineCodes!) {
      approveCodes(input:$input){
        internalStatus
        error
        success
      }
    }`,
    {
      input: queryVars,
    },
  )
}
